module.exports = __webpack_public_path__ + "static/media/user.376695a0.svg";